/**
 * Unapplied credit the biller should be told about before collecting
 * more money (gdn-3175).
 *
 * "Deal with the credit first" is genuinely correct bookkeeping — taking
 * a fresh payment while the patient is already in credit manufactures a
 * refund. The review state used to enforce that by hiding the collect
 * verb, which carried the advice by removing the capability. This
 * carries the advice instead.
 */
export interface CreditSuggestion {
  /** What an allocation verb can actually move. */
  allocatableCents: number;
}

/**
 * @param allocatableCents the summary's `account_allocatable_credit_cents`.
 *
 * Absent for two different reasons, both correctly absent:
 *   - `0`    — there is credit machinery but nothing left to move.
 *   - `null` — an older BE that does not report an allocatable figure at
 *              all, so no allocation verb exists to offer.
 *
 * The second is why this never falls back to a gross credit figure:
 * suggesting "apply it first" for credit that no verb can move sends the
 * biller to a dead end, which is worse than saying nothing.
 */
export const creditSuggestionOf = (
  allocatableCents: number | null | undefined,
): CreditSuggestion | null =>
  typeof allocatableCents === 'number' && allocatableCents > 0
    ? { allocatableCents }
    : null;
